import React, { useEffect, useState } from 'react';
import { Box, Container, Typography, useMediaQuery } from '@mui/material';
import { useNavigate } from 'react-router-dom';
import Confetti from 'react-confetti';
import { useAuthContext } from '../../../context/auth/AuthContext';
import LoadingNavBar from '../../../components/navbar/LoadingNavBar';
import { Loading } from '../../../components/loading/Loading';
import { useUserContext } from '../../../context/user_context/UserContext';
import { useTranslation } from 'react-i18next';
import { useOrganizationContext } from '../../../context/organization_context/OrganizationContext';

export default function Processing() {
    const { user } = useAuthContext();
    const { firebaseUser } = useUserContext();
    const { organization } = useOrganizationContext();
    const [showConfetti, setShowConfetti] = useState(true);
    const { t } = useTranslation();
    const isMobile = useMediaQuery('(max-width: 600px)');
    
    useEffect(() => {
        const timer = setTimeout(() => {
            setShowConfetti(false);
        }, 5000);

        return () => clearTimeout(timer);
    }, []);

    useEffect(() => {
        const setProcessingFlag = async () => {
            if (!user || !firebaseUser) return <><LoadingNavBar showLoginButton={true} /><Loading /></>
            try {
                // if (organization && organization.processing !== undefined) {
                //     if(!organization.processing) {
                //         await setOrganizationProcessing(firebaseUser.organization);
                //     } else {
                //         navigate('/home');
                //     }
                // }
            } catch (error) {
                console.error('Error setting processing flag:', error);
            }
        };

        setProcessingFlag();
    }, [user, firebaseUser, organization]);

    return (
        <>
            <LoadingNavBar showLoginButton={false} />
            {showConfetti && (
                <Confetti
                    width={window.innerWidth}
                    height={window.innerHeight}
                    numberOfPieces={200}
                    recycle={false}
                    colors={['#39ace7', '#102a43', '#486581', '#FFD700', '#FF69B4']}
                />
            )}
            <Box
                className="hero-section"
                sx={{
                mt: '55px',
                height: isMobile ? '100%' : '100vh',
                background: 'linear-gradient(135deg, rgba(57, 172, 231, 0.95), rgba(16, 42, 67, 0.95))',
                animation: 'gradientAnimation 15s ease infinite',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                '@keyframes gradientAnimation': {
                    '0%': { backgroundPosition: '0% 50%' },
                    '50%': { backgroundPosition: '100% 50%' },
                    '100%': { backgroundPosition: '0% 50%' },
                },
                }}
            >
                <Container 
                    maxWidth="sm" 
                    sx={{ 
                        flex: 1, 
                        display: 'flex', 
                        flexDirection: 'column',
                        justifyContent: 'center',
                        alignItems: 'center'
                    }}
                >
                    <Box
                        sx={{
                            backgroundColor: '#ffffff',
                            boxShadow: '0 8px 32px rgba(0, 0, 0, 0.12)',
                            borderRadius: 3,
                            p: { xs: 3, md: 4 },
                            width: '100%',
                            textAlign: 'center'
                        }}
                    >
                        <Typography 
                            variant="h4" 
                            gutterBottom 
                            sx={{ 
                                fontWeight: 700, 
                                color: '#102a43',
                                mb: 4,
                                letterSpacing: '-0.5px'
                            }}
                        >
                            🎉 Welcome to BiziSmart!
                        </Typography>
                        <Typography 
                            sx={{ 
                                mt: 3,
                                color: '#486581',
                                fontSize: '1.1rem',
                                lineHeight: 1.6,
                                maxWidth: '90%',
                                margin: '0 auto'
                            }}
                        >
                            We're finishing setting up your account. We'll notify you via email when your account is ready.
                        </Typography>
                        <Typography
                            sx={{
                                color: '#486581',
                                fontSize: '1.1rem',
                                lineHeight: 1.6,
                                mt: 2,
                                mb: 3
                            }}
                        >
                            Please note that you will be required to complete a short onboarding process with Stripe to access all of your account features.
                        </Typography>
                        <Typography
                            sx={{
                                color: '#102a43',
                                fontWeight: 600,
                                mt: 4
                            }}
                        >
                            The BiziSmart Team
                        </Typography>
                    </Box>
                </Container>
            </Box>
        </>
    );
}
